// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import ProjectCard from "./ProjectCard"

// Data / Images / Icons
import { SOFTWARE_PROJECTS } from "src/data/pages/softwares"

function ProjectCardGroup() {
  return (
    <div className="flex flex-wrap gap-7 justify-center mt-10">
        {SOFTWARE_PROJECTS?.slice(0, 3).map((project, index) => (
          <ProjectCard key={`project-${index}`} project={project} />
        ))}
      </div>
  )
}

export default ProjectCardGroup